import { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";

/**
 * Fetches the resolved form config from the API.
 * Returns field-level config (enabled, required, label) for dynamic form rendering.
 *
 * Shape: { fields: { reference: { enabled, required, label }, notes: { enabled, required, label } } }
 */
export default function useFormConfig() {
  const [formConfig, setFormConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await axiosInstance.get("/booking/formConfig");
        setFormConfig(response.data);
      } catch (err) {
        console.error("Failed to load form config, using defaults", err);
        setFormConfig(defaultConfig());
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return { formConfig, loading };
}

function defaultConfig() {
  return {
    fields: {
      reference: { enabled: true, required: false, label: "Reference" },
      notes: { enabled: true, required: false, label: "Notes" },
    },
    consent: {
      text: "",
      privacyPolicyUrl: "",
      privacyPolicyLinkText: "Privacy Policy",
    },
  };
}
